import { useAccountContext } from '@/contexts/account-context'
import { Anchor, Menu, UnstyledButton } from '@mantine/core'
import {
    Bell,
    LogIn,
    LogOut,
    Heart,
    MessageCircle,
    Package,
    Plus,
    Settings,
    Truck,
    User,
    UserCheck,
} from 'lucide-react'

const MyAccount = () => {
    const { customer, logout } = useAccountContext()

    if (!customer) {
        return (
            <Menu shadow="md" width={200}>
                <Menu.Target>
                    <UnstyledButton
                        className="p-2 transition-all duration-200 ease-out rounded hover:bg-neutral-100"
                        c="gray.6"
                    >
                        <User />
                    </UnstyledButton>
                </Menu.Target>

                <Menu.Dropdown>
                    <Anchor href="/sign-in" variant="text">
                        <Menu.Item
                            className="bg-[var(--btn-hover)] text-white hover:bg-[var(--primary)] no-underline transition-all duration-500"
                            icon={<LogIn size={14} />}
                        >
                            Se connecter
                        </Menu.Item>
                    </Anchor>

                    <Anchor href="/register" variant="text">
                        <Menu.Item color="gray" icon={<Plus size={14} />}>
                            S'inscrire
                        </Menu.Item>
                    </Anchor>
                </Menu.Dropdown>
            </Menu>
        )
    }

    return (
        <Menu shadow="md" width={200}>
            <Menu.Target>
                <UnstyledButton c="gray.6">
                    <UserCheck color="var(--primary)" />
                </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label>Votre compte</Menu.Label>
                <Anchor href="/account?tab=orders" variant="text">
                    <Menu.Item icon={<Package size={14} />}>
                        Mes commandes
                    </Menu.Item>
                </Anchor>

                <Anchor href="/account?tab=addresses" variant="text">
                    <Menu.Item icon={<Truck size={14} />}>
                        Mes adresses
                    </Menu.Item>
                </Anchor>

                <Anchor href="/account?tab=alerts" variant="text">
                    <Menu.Item icon={<Bell size={14} />}>
                        Mes alertes
                    </Menu.Item>
                </Anchor>

                <Anchor href="/account?tab=favorites" variant="text">
                    <Menu.Item icon={<Heart size={14} />}>
                        Mes favoris
                    </Menu.Item>
                </Anchor>

                <Anchor href="/account?tab=messages" variant="text">
                    <Menu.Item icon={<MessageCircle size={14} />}>
                        Messagerie
                    </Menu.Item>
                </Anchor>

                <Menu.Divider />
                <Anchor href="/account?tab=profile" variant="text">
                    <Menu.Item icon={<Settings size={14} />}>
                        Paramètres
                    </Menu.Item>
                </Anchor>
                <Menu.Item
                    color="red"
                    icon={<LogOut size={14} />}
                    onClick={logout}
                >
                    Déconnexion
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )
}

export default MyAccount
